import { FormItem, useAwait } from '@faceup/ui'
import { InputNumber, type InputNumberProps } from '@faceup/ui-base'
import type { FieldValues, UseControllerProps } from 'react-hook-form'
import { useCustomController } from '../hooks'
import type { FormItemWrapperProps } from '../typings'

type NumberInputProps<T extends FieldValues> = UseControllerProps<T> &
  Omit<InputNumberProps & FormItemWrapperProps, 'value' | 'defaultValue' | 'placeholder'> & {
    placeholder?: string | Promise<string>
  }
export const NumberInput = <T extends FieldValues>(props: NumberInputProps<T>) => {
  const {
    formItemProps,
    inputProps: { onChange: fieldOnChange, placeholder, ...inputProps },
  } = useCustomController(props)
  const awaitedPlaceholder = useAwait(placeholder)

  return (
    <FormItem {...formItemProps}>
      <InputNumber
        {...inputProps}
        placeholder={awaitedPlaceholder}
        onChange={e => {
          fieldOnChange(e)
          props.onChange?.(e)
        }}
      />
    </FormItem>
  )
}
